import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { ControlLogo } from "@/components/ControlLogo";

const IMAGE = "https://images.unsplash.com/photo-1617128610245-c348bcc22d36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen grid lg:grid-cols-2 auth-decor">
    <div className="flex flex-col px-6 py-8 sm:px-10 lg:px-16">
      <Link to="/logg-inn" className="inline-flex" data-testid="auth-brand" aria-label="Controlle">
        <ControlLogo size={34} tagline="Regninger og faktura, ett sted" />
      </Link>
      <div className="flex-1 flex items-center">
        <div className="w-full max-w-md mx-auto lg:mx-0 py-10">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-2 text-muted-foreground">{subtitle}</p> : null}
          <div className="mt-8 rounded-2xl border bg-card p-6 sm:p-8 shadow-sm">{children}</div>
          {footer ? <div className="mt-6 text-sm text-muted-foreground">{footer}</div> : null}
          <ul className="mt-8 grid gap-2 text-sm text-muted-foreground">
            {["Sikker, kryptert lagring av dokumenter", "Automatisk utlogging ved inaktivitet", "Administrator har aldri innsyn i fakturainnhold"].map((t) => (
              <li key={t} className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-primary shrink-0" /> {t}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    <div className="hidden lg:block relative">
      <img src={IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0b3b3e]/55" />
      <div className="absolute bottom-12 left-12 right-12 text-white">
        <p className="font-heading text-3xl font-semibold leading-tight">Full kontroll på regningene du får – og fakturaene du sender.</p>
        <p className="mt-3 text-white/85 max-w-lg">Samle inngående regninger fra eFaktura, e-post, Digipost og papir, og fakturer kundene dine med profesjonelle fakturaer – alt på ett sted.</p>
      </div>
    </div>
  </div>
);
